// deno-fmt-ignore-file
// deno-lint-ignore-file 
export function FromBase(context, type, value) {
    return type.Default(value);
}
